import React from 'react'
import { MAINSLIDER, SLIDER, STRIPE, HIGHLIGHT, SHOWTIMES, ADVERTISEMENT  } from '../constants/selectionTypes'
import SelectionAccess from './SelectionAccess'
import { getFrontpageSelectionHtmlId } from './SelectionsDisplayNavAccess'


const SelectionsDisplayAccess = ({
    order,
    items
}) => {
    return <div>
        {order && order.map(id => {
            const { selectionId, cinema, type }  = items[id]
            const htmlId = getFrontpageSelectionHtmlId(id, selectionId)

            // ToDo: SHOWTIMES & ADVERTISEMENT

            return (
                type === MAINSLIDER || type === SLIDER || type === STRIPE || type === HIGHLIGHT ? (
                    <SelectionAccess 
                        key={id}
                        htmlId={htmlId}
                        selectionId={selectionId}
                        cinema={cinema}
                    />
                ) : ''
            )
        })}
    </div>


}


export default SelectionsDisplayAccess